import ObjectAssign from 'es6-object-assign'
import Promise from 'promise-polyfill'
import 'string.prototype.includes'

if (!window.ObjectAssign) window.ObjectAssign = ObjectAssign.polyfill()
if (!window.Promise) window.Promise = Promise
if (!Number.isNaN) Number.isNaN = function isNaN (x) { return x !== x }


// WEBPACK FOOTER //
// ./polyfills.js